<script setup lang="ts">
import { BKModal } from '@/shared/ui/modals'
import { ref } from 'vue'

const showModal = ref(false)
</script>

<template>
  <div class="sponsor-banner">
    <picture class="sponsor-banner-picture">
      <source
        srcset="/img/banner.webp"
        media="(min-width: 616px)"
      />
      <source
        srcset="/img/banner-m.webp"
        media="(max-width: 615px)"
      />
      <img
        src="/img/banner.webp"
        alt=""
      />
    </picture>
    <div class="vignette-overlay" />
    <div class="sponsor-banner-content">
      <BKButton
        outlined
        color="transparent"
        white-text
        width="230px"
        class="button-transparent"
        @click="showModal = true"
      >
        Watch promo video
      </BKButton>
      <BKButton
        href="https://breakkonnect.com/event/3803"
        color="var(--color-white)"
        width="230px"
      >
        Register to Battle
      </BKButton>
    </div>
    <BKModal
      :is-show.sync="showModal"
      modal-width="100%"
    >
      <iframe
        v-if="showModal"
        width="100%"
        height="100%"
        class="video-embed"
        src="https://www.youtube-nocookie.com/embed/-FXLZDCi5YM?si=BmEiBcrlY63kmT8D"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen
      ></iframe>
      <BKButton
        class="button-modal"
        href="https://breakkonnect.com/event/3803"
        white-text
      >
        Register to Battle
      </BKButton>
    </BKModal>
  </div>
</template>

<style scoped lang="scss">
.sponsor-banner {
  position: relative;
  display: block;
  overflow: hidden;
  background-color: var(--color-dark-900);
}

.sponsor-banner-picture {
  position: relative;
}

.sponsor-banner-picture img {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 646px;
  object-fit: cover;

  @media (max-width: 615px) {
    min-height: 552px;
  }
}

.vignette-overlay {
  position: absolute;
  inset: 0;
  background-image: linear-gradient(
    to bottom,
    rgba(0 0 0 / 70%) 0%,
    rgba(0 0 0 / 0%) 30%,
    rgba(0 0 0 / 0%) 62%,
    rgba(0 0 0 / 70%) 100%
  );
}

.sponsor-banner-content {
  position: absolute;
  inset: 0;
  display: flex;
  flex-flow: wrap;
  gap: 20px;
  place-content: flex-end;
  justify-content: center;
  padding: 60px;

  @media (max-width: 615px) {
    padding: 32px;
  }

  .button-transparent {
    color: var(--color-white);
    background-color: transparent;
    transition: background-color 0.3s;

    &:hover {
      background-color: rgba(255 255 255 / 2%) !important;
    }
  }
}

.video-embed {
  width: 100%;
  height: auto;
  max-height: 80vh;
  margin: auto;
  aspect-ratio: 16 / 9;
}

.button-modal {
  margin-top: 20px;

  @media (min-width: 630px) {
    display: none;
  }
}
</style>
